import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { getConditionColor } from '../../styles/theme';
import { useTheme } from '../../styles/ThemeProvider';

interface Props {
  condition: string | null | undefined;
}

export function ConditionBadge({ condition }: Props) {
  const theme = useTheme();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        box: {
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-start',
          paddingHorizontal: 8,
          paddingVertical: 3,
          borderRadius: theme.radius.radiusSm,
          borderWidth: 1,
          gap: theme.spacing.xs,
        },
        text: {
          fontFamily: theme.fontFamily.body,
          fontSize: 11,
          letterSpacing: 0.4,
          textTransform: 'uppercase',
        },
      }),
    [theme],
  );

  if (!condition) return null;
  const color = getConditionColor(condition, theme);
  return (
    <View
      style={[
        styles.box,
        { borderColor: `${color}B3`, backgroundColor: `${color}14` },
      ]}
    >
      <Text style={[styles.text, { color }]}>{condition}</Text>
    </View>
  );
}
